<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<meta content="text/html; charset=utf-8" http-equiv="Content-Type"/><meta content="text/html; charset=UTF-8"/><title>An Amish Christmas</title><link href="default.css" rel="stylesheet" type="text/css"/><link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe.page-template+xml"/>
<p class="ctc" id="p0005-01-0"><span><a id="pagev"></a><a href="#/chapter1"><i>Glossary</i></a></span></p>
<p class="tx1" id="p0005-02-1"><span><i>ab im kopp </i>– off in the head, crazy</span></p>
<p class="tx1"><span><i>aenti </i>– aunt</span></p>
<p class="tx1"><span><i>baremlich </i>– terrible</span></p>
<p class="tx1"><span><i>bauchduch </i>– napkin</span></p>
<p class="tx1"><span><i>boppli </i>– baby or babies </span></p>
<p class="tx1"><span><i>bruder </i>– brother</span></p>
<p class="tx1"><span><i>daadi </i>– grandfather</span></p>
<p class="tx1"><span><i>daed </i>– dad</span></p>
<p class="tx1"><span><i>danki </i>– thanks</span></p>
<p class="tx1"><span><i>demut </i>– humility</span></p>
<p class="tx1"><span><i>dippy eggs </i>– eggs cooked over easy</span></p>
<p class="tx1"><span><i>Derr Herr </i>– God</span></p>
<p class="tx1"><span><i>dochder </i>– daughter</span></p>
<p class="tx1"><span><i>du bischt wilkumm </i>– you’re welcome</span></p>
<p class="tx1"><span><i>dummkopf </i>– dummy</span></p>
<p class="tx1"><span><i>Englisch </i>or <i>Englischer </i>– a non-Amish person</span></p>
<p class="tx1"><span><i>fraa </i>or <i>frau </i>– wife</span></p>
<p class="tx1"><span><i>Frehlicher Grischtdaag </i>– Merry Christmas</span></p>
<p class="tx1"><span><i>gebet </i>– prayer</span></p>
<p class="tx1"><span><i>gern schöna </i>– so willingly done</span></p>
<p class="tx1"><span><i>glay hotsli </i>– little heart (endearment)</span></p>
<p class="tx1"><span><i>grossmammi </i>– grandmother</span></p>
<p class="tx1"><span><i>guder mariye </i>– good morning</span></p>
<p class="tx1"><span><i>guten nacht </i>– good night</span></p>
<p class="tx1"><span><i>gut-n-owed </i>– good evening</span></p>
<p class="tx1"><span><i>gutguckich </i>– good-looking</span></p>
<p class="tx1"><span><i>gut </i>– good</span></p>
<p class="tx1"><span><i>halt </i>– stop</span></p>
<p class="tx1"><span><i>haus </i>– house</span></p>
<p class="tx1"><span><i>hatt </i>– hard</span></p>
<p class="tx1" id="p0006-01-0"><span><a id="pagevi"><i>herr </i>– mister</a></span></p><a id="pagevi">
<p class="tx1"><span><i>hochmut </i>– pride</span></p>
<p class="tx1"><span><i>in lieb </i>– in love</span></p>
<p class="tx1"><span><i>kaffi </i>– coffee</span></p>
<p class="tx1"><span><i>kapp </i>– prayer covering or cap</span></p>
<p class="tx1"><span><i>kind, kinder, kinner </i>– children or grandchildren</span></p>
<p class="tx1"><span><i>liebschen </i>– dearest</span></p>
<p class="tx1"><span><i>maedel </i>or <i>maed </i>– girl or girls</span></p>
<p class="tx1"><span><i>mamm </i>– mom</span></p>
<p class="tx1"><span><i>mammi </i>– grandmother</span></p>
<p class="tx1"><span><i>mann </i>– man</span></p>
<p class="tx1"><span><i>mei </i>– my</span></p>
<p class="tx1"><span><i>mudder </i>– mother</span></p>
<p class="tx1"><span><i>naerfich </i>– nervous</span></p>
<p class="tx1"><span><i>narrisch </i>– crazy</span></p>
<p class="tx1"><span><i>nee </i>– no</span></p>
<p class="tx1"><span><i>onkel </i>– uncle</span></p>
<p class="tx1"><span><i>ordnung </i>– the written and unwritten rules of the Amish; the understood behavior by which the Amish are expected to live, passed down from generation to generation. Most Amish know the rules by heart.</span></p>
<p class="tx1" id="p0006-02-2"><span>Pennsylvania <i>Deitsch </i>– Pennsylvania German, the language most commonly used by the Amish</span></p>
<p class="tx1"><span><i>recht </i>– right</span></p>
<p class="tx1"><span><i>redd-up </i>– clean up</span></p>
<p class="tx1"><span><i>rumschpringe </i>– running-around period when a teenager turns sixteen years old</span></p>
<p class="tx1"><span><i>sehr gut </i>– very good</span></p>
<p class="tx1"><span><i>seltsam </i>– weird</span></p>
<p class="tx1"><span><i>sohn </i>– son</span></p>
<p class="tx1"><span><i>wunderbaar </i>– wonderful</span></p>
<p class="tx1"><span><i>ya </i>– yes </span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter2.vue?76f9f1a6